const demos = {
  all_demos: 'Accesos demo',
  create: 'Crear demo',
  mode: 'Modalidad',
  mode_reuse: 'Usar cuenta demo existente',
  mode_new: 'Crear usuario nuevo',
  account_type: 'Tipo de usuario',
  type_student: 'Estudiante',
  type_teacher: 'Docente',
  country: 'País',
  school: 'Colegio demo',
  grade: 'Grado',
  account: 'Cuenta',
  demo_user: 'Alumno/Docente',
  client: 'Cliente',
  reason: 'Motivo',
  starting_date: 'Fecha de inicio',
  finish_date: 'Fecha de vencimiento',
  firstname: 'Nombre',
  lastname: 'Apellido',
  identifier: 'DNI o correo',
  created_title: 'Enlace demo creado',
  link: 'Enlace',
  copy_link: 'Copia el enlace',
  copied: 'Enlace copiado',
  revoke: 'Revocar',
  revoke_confirm: '¿Revocar este acceso demo?',
  login_count: 'Ingresos',
  last_login: 'Último ingreso',
  empty: 'No hay accesos demo creados',
  create_error: 'No se pudo crear el acceso demo',
  load_error: 'No se pudieron cargar los accesos demo. Inténtalo de nuevo.',
  revoke_error: 'No se pudo revocar el acceso demo. Inténtalo de nuevo.',
  revoked: 'Acceso demo revocado.',
};

export default demos;
